const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl } = wp.components;
import CommonPanel from '../wp-controlers/common-panel';

const Inspector = ({ attributes, setAttributes }) => {
  const { position } = attributes;

  return (
    <InspectorControls>
      <PanelBody>
        <SelectControl
          label="Seleciona a posição dos botões"
          value={position}
          options={[
            { label: 'Esquerda', value: 'left' },
            { label: 'Centro', value: 'center' },
            { label: 'Direita', value: 'right' },
            { label: 'Esquerda - Centro', value: 'left-center' },
            { label: 'Centro - Esquerda', value: 'center-left' },
          ]}
          onChange={(value) => setAttributes({ position: value })}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
